import "./Pool.css";

const Pool = () => {
  return <div>Pool</div>;
};

export default Pool;
